import React, { FC, memo } from "react";
import classNames from "classnames";
import loadable from "@loadable/component";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { Asset } from "@app/components/base-page/models";
import { FileType, checkFileType } from "@app/helpers/check-file-type";

const ReactPlayer = loadable(() => import("react-player"));

type Props = {
  media: Asset;
  className?: string;
};

const MediaBlock: FC<Props> = memo(({ media, className }) => (
  <div className={classNames(className)}>
    {checkFileType(media.filename) === FileType.VIDEO ? (
      <ReactPlayer
        className={classNames(
          "[&>video]:rounded-lg",
          "[&>video]:border-divider [&>video]:border",
          "[&>video]:aspect-[1.18] [&>video]:object-cover",
        )}
        url={media.filename}
        width="100%"
        height="auto"
        playing
        muted
        loop
        playsinline
        config={{
          file: {
            attributes: { disablePictureInPicture: true },
          },
        }}
      />
    ) : (
      <GatsbyImage
        image={getGatsbyImage(media.filename, { layout: "fullWidth" })}
        alt={media.alt}
        className={classNames("aspect-[1.18] w-full rounded-lg")}
      />
    )}
  </div>
));

MediaBlock.displayName = "MediaBlock";

export { MediaBlock };
